import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'component.Commons.PaginatedList.NoResult.title',
    defaultMessage: 'Nothing here yet',
  },
  message: {
    id: 'component.Commons.PaginatedList.NoResult.message',
    defaultMessage: 'If you think it’s because of any issue, please <link>contact us</link>',
  },
  mailTo: {
    id: 'component.Commons.PaginatedList.NoResult.contact.mailTo',
    defaultMessage: 'support@hubstairs.com',
  },
})
